module.exports = __webpack_public_path__ + "static/media/seamless-logo.da4e231f.svg";